/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewValidationError
 */
export interface CRSFSecReviewValidationError {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewValidationError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewValidationError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFSecReviewValidationError interface.
 */
export function instanceOfCRSFSecReviewValidationError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFSecReviewValidationErrorFromJSON(json: any): CRSFSecReviewValidationError {
    return CRSFSecReviewValidationErrorFromJSONTyped(json, false);
}

export function CRSFSecReviewValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFSecReviewValidationErrorToJSON(value?: CRSFSecReviewValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

